import React, { FC, createContext, useState, useRef } from "react";
import { ICard, IVerticalCardsIdandIndex } from "../interfaces";

interface IAddStrengthCardDemo {
    id: number | string, 
    description: string;
}
interface ISlotMachineContext {
    confirmSelectionDisabled: boolean;
    isConfirmSelectionClicked: boolean; 
    showIt: boolean;
    allStrengthCardsIdsState: any;
    lastDroppedCard: ICard | undefined;
    verticalCardIndexOfSelectedRow: any;
    verticalCardIdsAndTheirIndexes: IVerticalCardsIdandIndex[] | undefined;
    isIntroModalInSlotMachineOpen: boolean, 
    generateFiveNewStrengthCardsManually: boolean, 
    addStrengthCardDemo: IAddStrengthCardDemo, 
    deleteStrengthCardDemoById: number, 
    chosenStrengthCardsDemo: string[], 
    animateWhiteShaddowGlowingCards: boolean, 
    waitForTheOthersModal: boolean, 
    isConfirmButtonTipShown: boolean,
    showMidGameWaitingWindow: boolean, 
    setVerticalCardIdsAndTheirIndexes(verticalCardIdsAndTheirIndexes: any): void;
    setLastDroppedCard(lastDroppedCard: ICard | undefined): void;
    setShowIt(showIt: boolean): void;
    setIsConfirmSelectionClicked(isConfirmSelectionClicked: boolean): void;
    setConfirmSelectionDisabled(confirmSelectionDisabled: boolean): void;
    setIsIntroModalInSlotMachineOpen(isIntroModalInSlotMachineOpen: boolean): void;
    setGenerateFiveNewStrengthCardsManually(generateFiveNewStrengthCardsManually: boolean): void;
    setAddStrengthCardDemo(addStrengthCardDemo: IAddStrengthCardDemo): void;
    setDeleteStrengthCardDemoById(deleteStrengthCardDemoById: number): void;
    setChosenStrengthCardsDemo(chosenStrengthCardsDemo: string[]): void;
    setAnimateWhiteShaddowGlowingCards(animateWhiteShaddowGlowingCards: boolean): void;
    setWaitForTheOthersModal(waitForTheOthersModal: boolean): void;
    setIsConfirmButtonTipShown(isConfirmButtonTipShown: boolean): void;
    setShowMidGameWaitingWindow(showMidGameWaitingWindow: boolean): void;
}

const SlotMachineContext = createContext({} as ISlotMachineContext);
interface SlotMachineContextProps {
  children: React.ReactNode;
}

const SlotMachineContextProvider: FC<SlotMachineContextProps> = (props) => {
  const [confirmSelectionDisabled, setConfirmSelectionDisabled] = useState<boolean>(true);
  const [isConfirmSelectionClicked, setIsConfirmSelectionClicked] = useState<boolean>(false);
  const [showIt, setShowIt] = useState<boolean>(false);
  const [lastDroppedCard, setLastDroppedCard] = useState<ICard | undefined>();
  const [verticalCardIdsAndTheirIndexes, setVerticalCardIdsAndTheirIndexes] = useState<IVerticalCardsIdandIndex[]>([]);
  const [isIntroModalInSlotMachineOpen, setIsIntroModalInSlotMachineOpen] = useState<boolean>(true);
  const [generateFiveNewStrengthCardsManually, setGenerateFiveNewStrengthCardsManually] = useState<boolean>(true);
  const [addStrengthCardDemo, setAddStrengthCardDemo] = useState<IAddStrengthCardDemo>({id: 0, description: ""});
  const [deleteStrengthCardDemoById, setDeleteStrengthCardDemoById] = useState<number>(1111);
  const [chosenStrengthCardsDemo, setChosenStrengthCardsDemo] = useState<string[]>(["first", "second", "third", "fourth", "fifth"]);
  const [animateWhiteShaddowGlowingCards, setAnimateWhiteShaddowGlowingCards] = useState<boolean>(false);
  const [waitForTheOthersModal, setWaitForTheOthersModal] = useState<boolean>(false);
  const [isConfirmButtonTipShown, setIsConfirmButtonTipShown] = useState<boolean>(true);
  const [showMidGameWaitingWindow, setShowMidGameWaitingWindow] = useState<boolean>(false);
  

  const allStrengthCardsIdsState = useRef<number[]>([])
  const verticalCardIndexOfSelectedRow = useRef<number | undefined>();

  const providerValue = {
    confirmSelectionDisabled, 
    isConfirmSelectionClicked, 
    showIt, 
    lastDroppedCard, 
    verticalCardIdsAndTheirIndexes, 
    allStrengthCardsIdsState,
    verticalCardIndexOfSelectedRow,
    isIntroModalInSlotMachineOpen, 
    generateFiveNewStrengthCardsManually, 
    addStrengthCardDemo, 
    deleteStrengthCardDemoById, 
    chosenStrengthCardsDemo, 
    animateWhiteShaddowGlowingCards, 
    waitForTheOthersModal, 
    isConfirmButtonTipShown, 
    showMidGameWaitingWindow, 
    setVerticalCardIdsAndTheirIndexes,
    setLastDroppedCard,
    setShowIt,
    setIsConfirmSelectionClicked,
    setConfirmSelectionDisabled,
    setIsIntroModalInSlotMachineOpen,
    setGenerateFiveNewStrengthCardsManually,
    setAddStrengthCardDemo,
    setDeleteStrengthCardDemoById,
    setChosenStrengthCardsDemo,
    setAnimateWhiteShaddowGlowingCards,
    setWaitForTheOthersModal,
    setIsConfirmButtonTipShown,
    setShowMidGameWaitingWindow
  };

  return (
    <SlotMachineContext.Provider value={providerValue}>
      {props.children}
    </SlotMachineContext.Provider>
  );
};

export { SlotMachineContext, SlotMachineContextProvider };
